const normalize = (value = '') => String(value || '').toLowerCase();

const includesAny = (text, keywords = []) => keywords.some((keyword) => text.includes(keyword));

const uniqueLimit = (items, limit = 5) => Array.from(new Set(items.filter(Boolean))).slice(0, limit);

const artistMatchRules = [
  {
    keywords: ['singer', 'vocal', 'bhajan', 'qawwali', 'sufi', 'folk singer', 'playback', 'music'],
    matches: ['Live events', 'Music videos', 'Devotional programs', 'Brand jingles', 'Stage shows'],
  },
  {
    keywords: ['dancer', 'dance', 'kathak', 'bharatanatyam', 'odissi', 'hip-hop', 'choreographer'],
    matches: ['Stage shows', 'Cultural festivals', 'Music videos', 'Wedding events', 'Dance workshops'],
  },
  {
    keywords: ['actor', 'theatre', 'voice-over', 'anchor', 'emcee', 'comedian', 'stand-up'],
    matches: ['Films and reels', 'Theatre projects', 'Voice-over work', 'Events and hosting', 'Brand videos'],
  },
  {
    keywords: ['writer', 'poet', 'lyricist', 'script', 'dialogue', 'screenwriter', 'copywriter'],
    matches: ['Scripts', 'Lyrics', 'Brand content', 'Theatre writing', 'Film and web projects'],
  },
  {
    keywords: ['painter', 'sketch', 'illustrator', 'visual', 'photographer', 'graphic', 'animator', 'cinematographer', 'editor'],
    matches: ['Brand creatives', 'Album art', 'Portrait work', 'Event coverage', 'Digital campaigns'],
  },
  {
    keywords: ['influencer', 'creator', 'instagram', 'youtube', 'reels', 'social media'],
    matches: ['Brand collaborations', 'Reels campaigns', 'Product promotions', 'Event coverage', 'Audience building'],
  },
  {
    keywords: ['folk', 'traditional', 'regional', 'classical', 'devotional', 'cultural'],
    matches: ['Cultural festivals', 'Government events', 'Heritage programs', 'Stage performances', 'Workshops'],
  },
];

const collaboratorMatchRules = [
  {
    keywords: ['production', 'film', 'video', 'studio', 'agency', 'brand', 'campaign', 'advertising'],
    artists: ['Actors', 'Singers', 'Voice-over Artists', 'Dancers', 'Video Editors', 'Influencers'],
  },
  {
    keywords: ['event', 'wedding', 'festival', 'stage', 'concert', 'show'],
    artists: ['Singers', 'Dancers', 'Anchors', 'Live Bands', 'Folk Artists', 'Comedians'],
  },
  {
    keywords: ['school', 'college', 'institution', 'academy', 'workshop', 'training'],
    artists: ['Dance Teachers', 'Music Teachers', 'Theatre Artists', 'Folk Artists', 'Visual Artists'],
  },
  {
    keywords: ['theatre', 'play', 'drama'],
    artists: ['Theatre Actors', 'Scriptwriters', 'Dialogue Writers', 'Stage Hosts', 'Voice-over Artists'],
  },
  {
    keywords: ['music', 'label', 'audio', 'song', 'album'],
    artists: ['Singers', 'Composers', 'Lyricists', 'Instrumentalists', 'Music Producers'],
  },
  {
    keywords: ['social', 'influencer', 'creator', 'instagram', 'youtube', 'reels'],
    artists: ['Influencers', 'Content Creators', 'Reels Creators', 'Photographers', 'Video Editors'],
  },
];

export const getArtistMatchSuggestions = (artist = {}) => {
  const profileText = normalize([
    artist.category,
    artist.subcategory,
    artist.bio,
    artist.city,
  ].join(' '));

  const matches = artistMatchRules.flatMap((rule) =>
    includesAny(profileText, rule.keywords) ? rule.matches : [],
  );

  return uniqueLimit(matches.length ? matches : ['Creative projects', 'Events', 'Collaborations'], 5);
};

export const getCollaboratorMatchSuggestions = (collaborator = {}) => {
  const profileText = normalize([
    collaborator.organization_type,
    collaborator.organization_name,
    collaborator.bio,
    collaborator.city,
  ].join(' '));

  const matches = collaboratorMatchRules.flatMap((rule) =>
    includesAny(profileText, rule.keywords) ? rule.artists : [],
  );

  return uniqueLimit(matches.length ? matches : ['Singers', 'Dancers', 'Actors', 'Content Creators'], 6);
};

export const getMatchConfidenceLabel = (suggestions = []) => {
  if (suggestions.length >= 5) return 'Strong match signals';
  if (suggestions.length >= 3) return 'Good match signals';
  return 'Add more profile details for better matching';
};
